import { useDispatch, useSelector } from "react-redux";
import { pusher } from "@common/services/socketCommution";
import { reducerPaths } from "../../../../../app/reducerPaths";
import { setLiveAuctionMultipleFields } from "../../../../../toolkit/liveAuction/liveAuctionSlice";
import React from "react";
import { Bidding_Through } from "../../../../../utils/constants/auction";

const useLiveAuctionSocketEvents = ({
  Vehicle_Id,
  onNewBidHandler
}) => {

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // useSelector start...
  const liveAuction = useSelector(store => store[reducerPaths.liveAuction]);
  // useSelector end...

  // Handlers start...
  const onNewBidListener = (e) => {
    console.log(`bidHistorySocket`, e);
    if (e?.Bidding_Through !== Bidding_Through.Auction) {
      return;
    }
    
    if (onNewBidHandler) {
      onNewBidHandler();
    }
    // let newBidHistory = [
    //   {
    //     ...(e || {}),
    //     amount: e?.bidAmount,
    //     dealerId: e?.dealerId,
    //     Vehicle_Id: e?.vehicleId,
    //   },
    //   ...(liveAuction?.bidHistory?.data || []),
    // ];

    // console.log(newBidHistory, liveAuction?.bidHistory?.data, `newBidHistory`);
    // dispatch(
    //   setLiveAuctionMultipleFields({
    //     bidHistory: {
    //       ...liveAuction?.bidHistory,
    //       data: newBidHistory
    //     }
    //   })
    // )
  };
  // Handlers end...

  // useEffect start...
  React.useEffect(() => {
    const channel = pusher.subscribe(`bid-history.${Vehicle_Id}`);
    channel.bind(`new.bid`, onNewBidListener);

    return () => {
      channel.unbind(`new.bid`, onNewBidListener);
    }
  }, [Vehicle_Id, liveAuction?.bidHistory?.data]);
  // useEffect end...

};  

export {
  useLiveAuctionSocketEvents
};